module.exports = __webpack_public_path__ + "img/750-v.0d086a5b.jpg";